import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { getCandidateCountsQueryKey } from "@/hooks/data/use-candidate-counts";
import { getConnectionsCountQueryKey } from "@/hooks/data/use-connections-count";
import { User } from "@/lib/types/auth";

export default function useInvitesInvalidQueries(user: User) {
  const queryClient = useQueryClient();

  const invalidate = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: getCandidateCountsQueryKey(user.id),
    });

    queryClient.invalidateQueries({
      queryKey: getConnectionsCountQueryKey(user.id),
    });
  }, [queryClient, user]);

  return { invalidate };
}
